import { Flex, Image } from 'rebass';
import PropTypes from 'prop-types';
import React from 'react';
// import styled from '@emotion/styled';
import { useDispatch } from 'react-redux';
import { setSidebar } from 'ui/actions';
// import { CountIndicator } from '../item/styled';
import StoryFilterLink from '../stories-dropdown/link';
import { useLogout } from '../../../auth/logout';
import useLocation from 'app/hooks/location';
import bellRing from './assets/bell-ring.svg';
import { useMyChildJournals, useGiftCertificates } from 'account-dashboard/hooks';
import logOut from './assets/log-out.svg';
import { isSelfClaimedGift } from 'members/helper';
// const StyledCountIndicator = styled(CountIndicator)`
//   top: 14px;
//   left: 129px;
// `;


const MeDropdown = ({ handleClick = () => { }, journalId, isSelected, hasInitializedJournal, isFromHeader, closeSidebar }) => {
  const logout = useLogout();
  const { pathname } = useLocation();
  const dispatch = useDispatch();

  const { journals } = useMyChildJournals();
  const { giftCertificates, error } = useGiftCertificates();
  const giftedJournalIds = new Set(
    giftCertificates
      .filter(gift => !isSelfClaimedGift(gift))
      .map(({ childJournalId }) => childJournalId)
      .filter(Boolean)
  );
  const validJournals = journals
    .filter(({ id }) => !giftedJournalIds.has(id))

  const unassignedJournal = validJournals.find(
    ({ state }) => state === 'unassigned'
  );

  const myBookJournal = validJournals.find(
    ({ state }) =>
      state === 'initialized' ||
      state === 'assigned'
  );

  const accountRedirect = unassignedJournal ? "/account/unassigned" : myBookJournal ? "/account/my-books" : "/account/gifts"


  function onClick(e) {
    dispatch(setSidebar(false))
    handleClick(e)
  }

  return (
    <Flex flexDirection="column" alignItems="flex-start" ml={isFromHeader ? 0 : closeSidebar ? 1 : 3}>
      {hasInitializedJournal && (
        <StoryFilterLink path={`/child-journals/${journalId}/reminders`} style={{ color: pathname.includes('/reminders') ? "#9B59B6" : "#64748B", padding: isFromHeader ? '8px 1em' : '1em' }} handleClick={onClick}>
          <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
            <path d="M12.8608 13.7409H16.6006L15.5498 12.6901C15.2648 12.4051 15.1047 12.0186 15.1047 11.6156V9.25318C15.1047 7.29919 13.8559 5.63688 12.1129 5.02081V4.76544C12.1129 3.93927 11.4431 3.26953 10.6169 3.26953C9.79078 3.26953 9.12104 3.93927 9.12104 4.76544V5.02081C7.37801 5.63688 6.12921 7.29919 6.12921 9.25318V11.6156C6.12921 12.0186 5.96911 12.4051 5.68413 12.6901L4.6333 13.7409H8.37308M12.8608 13.7409V14.4889C12.8608 15.7281 11.8562 16.7327 10.6169 16.7327C9.37769 16.7327 8.37308 15.7281 8.37308 14.4889V13.7409M12.8608 13.7409H8.37308" stroke={pathname.includes('/reminders') ? "#9B59B6" : "#64748B"} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M15.7311 3.57806C16.1241 3.7332 16.4619 4.0021 16.7013 4.35033C16.9406 4.69856 17.0706 5.11029 17.0745 5.53282M17.513 0.805343C18.3428 1.05649 19.0625 1.58231 19.554 2.29647C20.0455 3.01064 20.2795 3.87069 20.2177 4.73543" stroke={pathname.includes('/reminders') ? "#9B59B6" : "#64748B"} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M5.24645 3.57806C4.85342 3.7332 4.51562 4.0021 4.27629 4.35033C4.03696 4.69856 3.90698 5.11029 3.903 5.53282M3.46451 0.805343C2.63475 1.05649 1.91503 1.58231 1.42355 2.29647C0.932059 3.01064 0.69801 3.87069 0.75983 4.73543" stroke={pathname.includes('/reminders') ? "#9B59B6" : "#64748B"} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          </svg> {!closeSidebar && <>&nbsp;&nbsp; Set Reminders</>}
        </StoryFilterLink>
      )}
      <StoryFilterLink path="/profile" style={{ color: (pathname.includes('/profile')) ? "#9B59B6" : "#64748B", padding: isFromHeader ? '8px 1em' : '1em' }} handleClick={onClick}>
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
          <path d="M15 15.75V14.25C15 13.4544 14.6839 12.6913 14.1213 12.1287C13.5587 11.5661 12.7956 11.25 12 11.25H6C5.20435 11.25 4.44129 11.5661 3.87868 12.1287C3.31607 12.6913 3 13.4544 3 14.25V15.75" stroke={(isSelected || pathname.includes('/profile')) ? "#9B59B6" : "#64748B"} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M9 8.25C10.6569 8.25 12 6.90685 12 5.25C12 3.59315 10.6569 2.25 9 2.25C7.34315 2.25 6 3.59315 6 5.25C6 6.90685 7.34315 8.25 9 8.25Z" stroke={(pathname.includes('/profile')) ? "#9B59B6" : "#64748B"} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg> {!closeSidebar && <>&nbsp;&nbsp; My Profile</>}
      </StoryFilterLink>
      <StoryFilterLink path={accountRedirect} style={{ color: pathname.includes('/account') ? "#9B59B6" : "#64748B", padding: isFromHeader ? '8px 1em' : '1em' }} handleClick={onClick}>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M2.5 6.66797V15.8346C2.5 17.6688 3.995 18.3346 5 18.3346H17.5V16.668H5.01C4.625 16.658 4.16667 16.5063 4.16667 15.8346C4.16667 15.7505 4.17417 15.6755 4.18667 15.6071C4.28 15.1271 4.67333 15.0096 5.01 15.0013H17.5V3.33464C17.5 2.41547 16.7525 1.66797 15.8333 1.66797H5C3.995 1.66797 2.5 2.3338 2.5 4.16797V6.66797ZM5 3.33464H15.8333V13.3346H4.16667V4.16797C4.16667 3.4963 4.625 3.34464 5 3.33464Z"
            fill={pathname.includes('/account') ? "#9B59B6" : "#64748B"} />
          <path d="M9.1665 11.6667H10.8332V9.16667H13.3332V7.5H10.8332V5H9.1665V7.5H6.6665V9.16667H9.1665V11.6667Z" fill={pathname.includes('/account') ? "#9B59B6" : "#64748B"} />
        </svg> {!closeSidebar && <>&nbsp;&nbsp; My Account</>}
      </StoryFilterLink>
      {/* <StoryFilterLink path="/friends/add" handleClick={handleClick}>
        <FontAwesome name="user-plus" /> Add Friend
      </StoryFilterLink>
      <StoryFilterLink path="/friends" handleClick={handleClick}>
        <FontAwesome name="users" /> My Friends
        {!!indicatorCount && <StyledCountIndicator>{indicatorCount}</StyledCountIndicator>}
      </StoryFilterLink> */}
      <StoryFilterLink
        path="/"
        handleClick={() => {
          onClick();
          logout();
        }}
        style={{ color: "#64748B", padding: isFromHeader ? '8px 1em' : '1em' }}
      >
        <Image src={logOut} /> {!closeSidebar && <>&nbsp;&nbsp; Log Out</>}
      </StoryFilterLink>
    </Flex>
  );
};

MeDropdown.propTypes = {
  handleClick: PropTypes.func.isRequired,
  indicatorCount: PropTypes.number.isRequired,
};

export default MeDropdown;
